import {
  Flex,
  Box,
  Heading,
  SimpleGrid,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Textarea,
  useColorModeValue
} from '@chakra-ui/react';
import { CheckIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import { useState, useEffect } from 'react';

function ScriptSelector({ generatedScripts = [], onSelect }) {
  const [selectedScriptIndex, setSelectedScriptIndex] = useState(generatedScripts.length > 0 ? 0 : null);
  const [customScript, setCustomScript] = useState('');

  const checkIconColor = useColorModeValue('brand.800', 'purple.800');
  const hoverColor = useColorModeValue('gray.50', 'purple.800');
  const textColor = useColorModeValue('gray.700', '#fff');

  useEffect(() => {
    if (generatedScripts.length > 0 && selectedScriptIndex === 0) {
      const defaultScript = generatedScripts[0];
      onSelect({
        script: defaultScript.paragraphs,
        script_style: defaultScript.script_style,
      });
    }
  }, [generatedScripts]);

  const handleCardSelect = (script, index) => {
    setSelectedScriptIndex(index);
    setCustomScript('');
    onSelect({ script: script.paragraphs, script_style: script.script_style });
  };

  const handleCustomScriptChange = (value) => {
    setSelectedScriptIndex(null);
    setCustomScript(value);
    onSelect({ script: value, script_style: 'custom' });
  };

  return (
    <Flex direction="column" p={2} width="640px">
      <Heading fontSize="2xl" mb={4}>
        Choose or create your script
      </Heading>

      <Tabs
        size="sm"
        variant={'enclosed-colored'}
        colorScheme='brand'
        width="100%"
        display="flex"
        flexDirection="column"
        flex={1}
        gap={2}
      >
        <TabList width="100%" justifyContent={'space-around'}>
          <Tab
            flex={1}
          >Choose script from AI</Tab>
          <Tab
            flex={1}
          >Use your own script</Tab>
        </TabList>

        <TabPanels>
          {/* Tab 1: AI Script Cards */}
          <TabPanel>
            <SimpleGrid columns={[1]} spacing={4}>
              {generatedScripts?.map((script, index) => (
                <Box
                  key={index}
                  borderWidth="1.5px"
                  borderColor={selectedScriptIndex === index ? checkIconColor : 'gray.200'}
                  borderRadius="lg"
                  p={3}
                  cursor="pointer"
                  onClick={() => handleCardSelect(script, index)}
                >
                  <Flex align="center" gap={2} mb={2}>
                    {selectedScriptIndex === index && <CheckIcon color="white" bg={checkIconColor} borderRadius="full" p="1" boxSize={5} />}
                    <Text fontWeight="bold">{script.title}</Text>
                  </Flex>
                  <Flex p={2} _hover={{ bg: hoverColor, borderRadius: 'lg' }}>
                    <Text fontSize="12px" color={textColor}>
                      {script.paragraphs}
                    </Text>
                  </Flex>
                </Box>
              ))}
            </SimpleGrid>
          </TabPanel>

          {/* Tab 2: Custom Script Input */}
          <TabPanel>
            <Textarea
              fontSize={'12px'}
              rows={10}
              value={customScript}
              onChange={(e) => handleCustomScriptChange(e.target.value)}
              placeholder="Enter your script here ..."
            />
            <Flex direction="column" mt={2} gap={1}>
              <Flex align="center" gap={1}>
                <InfoOutlineIcon boxSize={3.5} />
                <Text fontSize="12px">Instructions for Input:</Text>
              </Flex>
              <Flex direction="column" ml={4} gap={1}>
                <Text fontSize="12px">Please ensure compliance with regulations.</Text>
                <Text fontSize="12px">Please enter plain text and ensure sentences flow naturally.</Text>
                <Text fontSize="12px">Avoid formatting expressions (e.g., Genre: Lighthearted).</Text>
                <Text fontSize="12px">Avoid any inappropriate content, such as explicit or violent material.</Text>
                <Text fontSize="12px">Avoid using special characters such as ##, [], --, **</Text>
              </Flex>
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
}


export default ScriptSelector;